import { uniqueId } from 'lodash'
import React, { useRef } from 'react'
import { Column, Grid, Row } from '../../../Grid'
import './index.scss'

const Inline = ({ data }) => {
  const ref = useRef(null)

  // TODO nel caso volessimo un approccio basato sul resize di pagina
  // const [dimensions, setDimensions] = useState({
  //   height: ref?.current?.clientHeight,
  //   width: ref?.current?.clientWidth
  // })

  // useEffect(() => {
  //   function handleResize() {
  //     setDimensions({
  //       height: ref?.current?.clientHeight,
  //       width: ref?.current?.clientWidth
  //     })
  //   }
  //
  //   window.addEventListener('resize', handleResize)
  //
  //   return _ => {
  //     window.removeEventListener('resize', handleResize)
  //
  //   }
  // }, [])

  return (
    <div ref={ref}>
      <Grid className='KPI-inline-grid'>
        <Row className='KPI-inline-row'>
          {data?.map(({ title, value }) => (
            <Column key={uniqueId('KPI_INLINE_')} sm={2} md={2} lg={2}>
              <div className='KPI-inline-box'>
                <h6 className='KPI-inline-title'>{title}:</h6>
                <p className='KPI-inline-value'>{value}</p>
              </div>
            </Column>
          ))}
        </Row>
      </Grid>
    </div>
  )
}

export default Inline
